const DEV_AGENCY_KEY = '__dev_agency_domain';
export function getDevAgencyDomain() {
    if (typeof window === 'undefined')
        return null;
    return localStorage.getItem(DEV_AGENCY_KEY);
}
export function setDevAgencyDomain(domain) {
    localStorage.setItem(DEV_AGENCY_KEY, domain);
}
export const isDevMode = process.env.NODE_ENV === 'development';
